<div class="modal-body" id="project-invoice">
  <ag-grid-angular
      #topGrid
      *ngIf="invoices.length > 0"
      style="height:240px;"
      class="ag-theme-alpine pps-top-grid"
      [context]="context"
      [rowData]="invoices"
      [columnDefs]="gridHeaders"
      [gridOptions]="topOptions"
      rowSelection="single">
  </ag-grid-angular>
  <ag-grid-angular
      #bottomGrid
      *ngIf="invoices.length > 0"
      style="height: 34px;"
      class="ag-theme-alpine pps-bottom-grid"
      headerHeight="0"
      [context]="context"
      [rowData]="invoiceTotal"
      [columnDefs]="gridHeaders"
      [gridOptions]="bottomOptions"
      [rowStyle]="{ fontWeight: 'bold', backgroundColor: '#eeeeee'}"
      (gridReady)="onGridReady($event)"
      rowSelection="single">
  </ag-grid-angular>
</div>

<div class="modal-footer">
  <button pButton pRipple label="Close" class="p-button" icon="pi pi-times" type="button" (click)="cancel()"></button>
</div>
